import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDialog } from '../../../components/dialogs/form-dialog';
import { ExtractedDataProvider } from './extracted-data-context';

interface AddItemDialogProps {
  open: boolean;
  onClose: () => void;
  isSubmitting: boolean;
  isValid: boolean;
  onSubmit: () => void;
  children: ReactNode;
  isEditMode?: boolean;
  onTransitionExited?: () => void;
}

export function AddItemDialog({
  open,
  onClose,
  isSubmitting,
  isValid,
  onSubmit,
  children,
  isEditMode = false,
  onTransitionExited,
}: AddItemDialogProps) {
  const { t } = useTranslation();

  const title = isEditMode ? t('goodsReceiving.editItem') : t('goodsReceiving.addItem');

  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title={title}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      isValid={isValid}
      onTransitionExited={onTransitionExited ?? (() => undefined)}
    >
      <ExtractedDataProvider>{children}</ExtractedDataProvider>
    </FormDialog>
  );
}
